import styled, { css } from 'styled-components';

interface RewardsCardsProps {
  backgroundImage: string;
}

export const RewardsCardWrapper = styled.div(
  ({ backgroundImage }: RewardsCardsProps) => {
    const encodedImage = encodeURI(backgroundImage)
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');
    return css`
      background-image: url(https://assets1.cleartax-cdn.com/${encodedImage});
      background-size: 100% 100%;
    `;
  }
);
